module.exports = __webpack_public_path__ + "img/logo-denib.b4e164fe.svg";